import { Controller } from "@hotwired/stimulus";
import Swiper, {
    Navigation,
    Swiper as SwiperType,
    SwiperOptions,
} from "swiper";
import inBackend from "../../../../inBackend";

const SLIDE_CLASS = "content-slider__slide";
const SLIDER_CLASS = "content-slider";

Swiper.use([Navigation]);

export default class extends Controller {
    // workaround to type readonly element
    // this will return the element that was detected as controller
    get el(): HTMLElement {
        return this.element as HTMLElement;
    }
    static targets = ["swiper"]

    swiperTarget!: HTMLElement;

    // Swiper
    swiper: SwiperType | null = null;
    inBackend = inBackend();

    connect() {
        const swiperOptions: SwiperOptions = {
            speed: 500,
            direction: "horizontal",
            loop: true,

            // Navigation arrows
            navigation: {
                nextEl: ".content-slider__next",
                prevEl: ".content-slider__prev",
            },
        };

        // this would otherwise create copies of the slides breaking
        // the index calculation
        if (this.inBackend) swiperOptions.loop = false;

        this.swiper = new Swiper(this.swiperTarget, swiperOptions);

        // Backend Optimizations
        if (this.inBackend) {
            // to prevent scrolling on click when in backend
            this.swiper.detachEvents();
            document.addEventListener(
                "Neos.NodeSelected",
                this.nodeSelected.bind(this)
            );
            document.addEventListener(
                "Neos.NodeRemoved",
                this.nodeRemoved.bind(this)
            );
            document.addEventListener(
                "Neos.NodeCreated",
                this.nodeSelected.bind(this)
            );
        }
    }

    // Backend Optimizations
    getSlideIndex(element: HTMLElement): number {
        const slides = Array.from(this.el.querySelectorAll(`.${SLIDE_CLASS}`));
        return slides.indexOf(element);
    }

    isSlide(element: HTMLElement) {
        return element.classList.contains(SLIDE_CLASS);
    }

    isOwnSlide(element: HTMLElement) {
        if (!this.isSlide(element)) return false;
        return element.closest(`.${SLIDER_CLASS}`) === this.el;
    }

    nodeSelected(event: any) {
        if (this.swiper && this.isOwnSlide(event.detail.element)) {
            const index = this.getSlideIndex(event.detail.element);
            if (index >= 0) {
                this.swiper.update();
                this.swiper.slideTo(index);
            }
        }
    }

    nodeRemoved(event: any) {
        if (this.swiper && this.isSlide(event.detail.element)) {
            // we update all sliders in the page as the parent is null
            // and we cannot check if it is our own slide
            this.swiper.update();
        }
    }

    nodeCreated(event: any) {
        if (this.swiper && this.isOwnSlide(event.detail.element)) {
            this.swiper.update();
        }
    }
}
